// extracted by css-extract-rspack-plugin
export default {"cls1":"AddToListButton-cls1_J6c","cls2":"AddToListButton-cls2_GIa AddToListButton-cls1_J6c"};